// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface InternalTeamMemberDTO
 */
export interface InternalTeamMemberDTO {
    /**
     * 
     * @type {string}
     * @memberof InternalTeamMemberDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InternalTeamMemberDTO
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalTeamMemberDTO
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof InternalTeamMemberDTO
     */
    team: InternalTeamMemberDTOTeamEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalTeamMemberDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof InternalTeamMemberDTO
     */
    updatedAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InternalTeamMemberDTOTeamEnum {
    SALES = 'SALES'
}



